<template>
  <div>
    <!-- Modal de Loading -->
    <b-modal ref="modalLoadingPgto" size="xl" title="Carregando" :no-close-on-backdrop="true" :no-close-on-esc="true"
      :hide-footer="true">
      <div class="my-4">
        <div class="d-flex justify-content-center mb-3">
          <b-spinner variant="primary" style="width: 3rem; height: 3rem;" label="Large Spinner"></b-spinner>
        </div>
      </div>
    </b-modal>

    <!-- Modal de Pagamento Recusado (Cartão) -->
    <b-modal ref="ModalPagamentoCartaoRealtime" title="Pagamento Recusado">
      <p>Pagamento recusado! Verifique os dados do cartão e tente novamente.</p>
    </b-modal>

    <!-- Modal do Boleto/PIX -->
    <b-modal ref="modalBoletoRealtime" :size="sizemodalboleto" scrollable title="Pagamento" id="modalBoletoRealtime">
      <div v-if="pdf_boleto">
        <div v-if="sizemodalboleto == 'lg'">
          <div class="col-12 text-center">
            <img src="~@/assets/imgs/logo.svg" class="w-50" />
            <br><br><br><br>
            <h4><b>Valor R$: {{ valorFormatado }}</b></h4>
            <br /><br />
          </div>
          <div class="offset-4 col-8 text-center qrcodePix">
            <b-embed type="iframe" aspect="1by1" :src="pdf_boleto" allowfullscreen></b-embed>
          </div>
          <div class="col-12 text-center">
            <h4><b>Faça a leitura do QR CODE e aguarde.</b></h4>
            <h4><b>Ou</b></h4>
            <b-card>
              <h5><b>LINK DE PAGAMENTO (PIX COPIA E COLA)</b></h5>
              <textarea class="textarea" ref="copiarRealtime" v-model="linkPIX" cols="80" rows="4"></textarea>
              <b-button variant="primary" @click="copiarLink()">
                <font-awesome-icon icon="copy" /> &nbsp;&nbsp;&nbsp;&nbsp; Copiar link de pagamento
              </b-button>
            </b-card>
            <h4><b><br><br>Consulta de pagamento em {{ secondcd }} segundos.</b></h4>
          </div>
        </div>
        <div v-else>
          <b-embed type="iframe" aspect="1by1" :src="pdf_boleto" allowfullscreen></b-embed>
        </div>
      </div>
      <p v-else class="mensagemErro bold">{{ mensagemBolErro }}</p>
    </b-modal>

    <!-- Modal Principal de Pagamento -->
    <b-modal
      :ref="'modalPagamentoRealtime_' + modalId"
      :id="'modalPagamentoRealtime_' + modalId"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      :hide-header-close="processando"
      size="lg"
    >
      <template v-slot:modal-header>
        <h5>Selecione a forma de pagamento</h5>
      </template>
      <template v-slot:default>
        <b-form-select
          id="input-forma-pgto-realtime"
          v-model="formaPagamentoSelecionada"
          :options="formasPagamentoOpcoes"
          @change="onChangeFPG"
        ></b-form-select>

        <div v-if="formaPagamentoSelecionada && formaPagamentoSelecionada.toString().includes('credit')" class="mt-4">
          <b-card bg-variant="light" title="Dados do cartão">
            <parcela-checkout
              :environment="ENVIRONMENT_EXPRESS"
              :clientKey="CLIENT_KEY_EXPRESS"
              :apiUrl="URL_EXPRESS"
              :sellerKey="SELLER_KEY_EXPRESS"
              successReturnUrl="https://success-url.com.br"
              errorReturnUrl="https://error-url.com.br"
            />
          </b-card>
        </div>

        <p class="mt-3">Caso o pagamento não seja realizado na data de vencimento, o pedido será automaticamente cancelado.</p>
        <br>
        <p><b style="color: red;">*Após realizado o pagamento, os pedidos não poderão mais ser cancelados</b></p>
        <br>
        <p>O processamento dos pagamentos são realizados pela Parcela Express Servicos Digitais.</p>
      </template>
      <template v-slot:modal-footer>
        <b-button size="lg" variant="danger" class="mr-auto" @click="cancelar" :disabled="processando">Cancelar</b-button>
        <b-button
          size="lg"
          variant="success"
          @click="confirmar"
          :disabled="processando || !formaPagamentoSelecionada"
          v-if="!formaPagamentoSelecionada || !formaPagamentoSelecionada.toString().includes('credit')"
        >Aceitar</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import API from '@/services/api';
import axios from 'axios';
import '@parcelaexpress/checkout-component-js';

export default {
  name: 'ModalPagamentoRealtime',
  props: {
    /**
     * Identificador único para este modal (evita conflito de IDs quando há múltiplos na página)
     */
    modalId: {
      type: String,
      default: 'default',
    },
    /**
     * Valor do pagamento (ex: row.vl_custa)
     */
    value: {
      type: [Number, String],
      default: 0,
    },
    /**
     * Formas de pagamento disponíveis.
     * Valores suportados: 3 (PIX), 4 ou strings 'credit_*' (CC)
     * Padrão: apenas CC e PIX (realtime)
     */
    formasPagamento: {
      type: Array,
      default: () => [
        { text: 'Selecione uma opção de pagamento', value: 0 },
        { text: 'PIX - Parcela Express ( Gratuito )', value: 3 },
      ],
    },
  },
  data() {
    return {
      formaPagamentoSelecionada: 0,
      formasPagamentoOpcoes: [],
      formasPagamentoExpress: [],
      pdf_boleto: null,
      linkPIX: '',
      mensagemBolErro: '',
      sizemodalboleto: 'xl',
      secondcd: 30,
      processando: false,
      dadosTitulo: null,
      CLIENT_KEY_EXPRESS: process.env.VUE_APP_CLIENT_KEY_EXPRESS,
      SELLER_KEY_EXPRESS: process.env.VUE_APP_SELLER_KEY_EXPRESS,
      URL_EXPRESS: process.env.VUE_APP_URL_EXPRESS,
      ENVIRONMENT_EXPRESS: process.env.VUE_APP_ENVIRONMENT_EXPRESS,
    };
  },
  computed: {
    valorFormatado() {
      if (!this.value) return 'R$ 0,00';
      let v = parseFloat(this.value).toFixed(2).toString();
      v = v.replace('.', ',');
      v = v.replace(/(\d)(\d{3}),/g, '$1.$2,');
      return 'R$ ' + v;
    },
  },
  methods: {
    /**
     * Exibe diretamente o QR Code PIX de um pagamento já gerado,
     * consultando GET /pedido_retirada/{id}/dados-pagamento.
     */
    async abrirVisualizarPix(dadosTitulo) {
      this.dadosTitulo = dadosTitulo;
      this.pdf_boleto = null;
      this.linkPIX = '';
      this.mensagemBolErro = '';
      this.processando = true;
      this.sizemodalboleto = 'lg';

      this.$refs['modalLoadingPgto'].show();

      const token = localStorage.getItem('jwtToken');
      const cd_pedido_retirada = dadosTitulo.cd_pedido_retirada;

      try {
        const res = await API.get('pedido_retirada/' + cd_pedido_retirada + '/dados-pagamento', {
          params: { token: token },
        });

        if (res.data.success == true) {
          const idBoleto  = res.data.cd_boleto;
          const urlBoleto = res.data.urlBoleto;

          this.linkPIX = urlBoleto;
          const Quickchart = 'https://quickchart.io/qr?size=300&text=';
          this.pdf_boleto = Quickchart + encodeURI(this.linkPIX);
          this.startCountDown(30);
          const self = this;
          const countInterval2 = setInterval(function() {
            self.startCountDown(30);
            self.verificaPagamento(idBoleto);
          }, 30000);
          this.$root.$on('bv::modal::hidden', function(bvEvent, modalId) {
            if (modalId === 'modalBoletoRealtime' && bvEvent.type === 'hidden') {
              clearInterval(countInterval2);
            }
          });
          this.$refs['modalLoadingPgto'].hide();
          this.$refs['modalBoletoRealtime'].show();
        } else {
          this.mensagemBolErro = res.data.message || 'Não foi possível recuperar o QR Code. Tente novamente.';
          this.$refs['modalLoadingPgto'].hide();
          this.$refs['modalBoletoRealtime'].show();
        }
      } catch (err) {
        this.mensagemBolErro = 'Erro ao recuperar o QR Code. Tente novamente ou contate o suporte.';
        this.$refs['modalLoadingPgto'].hide();
        this.$refs['modalBoletoRealtime'].show();
        console.error(err);
      } finally {
        this.processando = false;
      }
    },

    /**
     * Abre o modal para o item fornecido
     */
    async abrir(dadosTitulo) {
      this.dadosTitulo = dadosTitulo;
      this.formaPagamentoSelecionada = 0;
      this.pdf_boleto = null;
      this.linkPIX = '';
      this.mensagemBolErro = '';
      this.processando = false;
      this.formasPagamentoOpcoes = [];
      this.formasPagamentoExpress = [];

      // Usa vl_custa do item diretamente — não depende da prop :value que pode
      // ainda não ter sido atualizada pelo Vue no mesmo ciclo de renderização
      const valorParaSimular = parseFloat(dadosTitulo.vl_custa) || parseFloat(this.value) || 0;
      await this.simulacaoPagamentos(valorParaSimular);

      this.$refs['modalPagamentoRealtime_' + this.modalId].show();
    },

    cancelar() {
      this.$refs['modalPagamentoRealtime_' + this.modalId].hide();
    },

    async confirmar() {
      if (!this.formaPagamentoSelecionada || this.formaPagamentoSelecionada == 0) return;

      this.processando = true;
      this.$refs['modalLoadingPgto'].show();

      const token = localStorage.getItem('jwtToken');
      const cd_pedido_retirada = this.dadosTitulo.cd_pedido_retirada;

      try {
        const res = await API.post(`pedido_retirada/${cd_pedido_retirada}/gerar-pagamento`, {
          formaPagamento: this.formaPagamentoSelecionada,
          token,
        });

        if (res.data.situacao == 1 || res.data.success == true) {
          const idBoleto   = res.data.idBoleto   != null ? res.data.idBoleto   : res.data.cd_boleto;
          const urlBoleto  = res.data.ds_endereco_boleto != null ? res.data.ds_endereco_boleto : res.data.urlBoleto;

          if (this.formaPagamentoSelecionada.toString().includes('credit')) {
            // Cartão de crédito — exibe boleto
            const resPdf = await API.post('certidao/exibeBoleto/' + idBoleto, { token });
            this.pdf_boleto = resPdf.data.ds_endereco_boleto;
            this.$refs['modalLoadingPgto'].hide();
            this.$refs['modalBoletoRealtime'].show();
          } else if (this.formaPagamentoSelecionada == 3) {
            // PIX
            this.linkPIX = urlBoleto;
            const Quickchart = 'https://quickchart.io/qr?size=300&text=';
            this.pdf_boleto = Quickchart + encodeURI(this.linkPIX);
            this.sizemodalboleto = 'lg';
            this.startCountDown(30);
            const self = this;
            const countInterval2 = setInterval(() => {
              self.startCountDown(30);
              self.verificaPagamento(idBoleto);
            }, 30000);
            this.$root.$on('bv::modal::hidden', (bvEvent, modalId) => {
              if (modalId === 'modalBoletoRealtime' && bvEvent.type === 'hidden') {
                clearInterval(countInterval2);
              }
            });
            this.$refs['modalLoadingPgto'].hide();
            this.$refs['modalPagamentoRealtime_' + this.modalId].hide();
            this.$refs['modalBoletoRealtime'].show();
          }
          this.$emit('pagamento-realizado');
        } else {
          this.mensagemBolErro = res.data.mensagem;
          this.$refs['modalLoadingPgto'].hide();
          this.$refs['modalBoletoRealtime'].show();
        }
      } catch (err) {
        this.mensagemBolErro = 'Erro ao realizar a solicitação. Tente novamente ou contate o suporte.';
        this.$refs['modalLoadingPgto'].hide();
        this.$refs['modalBoletoRealtime'].show();
        console.error(err);
      } finally {
        this.processando = false;
      }
    },

    async onChangeFPG() {
      if (!this.formaPagamentoSelecionada || !this.formaPagamentoSelecionada.toString().includes('credit')) return;

      const self = this;
      const token = localStorage.getItem('jwtToken');
      let retornoIP = await axios.get('https://api.ipify.org/?format=json');
      let costumerBillinAdrres = await API.get(`usuario/logado/endereco?token=${token}`);
      costumerBillinAdrres = costumerBillinAdrres.data;

      const description = self.dadosTitulo.cd_pedido_protesto.toString();

      setTimeout(() => {
        const web_component = document.querySelector('parcela-checkout');
        const dadosFormaPagamento = self.formasPagamentoExpress.find(d => d.code == self.formaPagamentoSelecionada);
        if (!dadosFormaPagamento) return;
        const amount_cents = parseInt(dadosFormaPagamento.total_amount_cents);

        web_component.customerData = {
          amount_cents,
          description,
          form_payment: 'credit',
          installment_plan: {
            number_installments: dadosFormaPagamento.installment,
          },
          customer: {
            email: localStorage.getItem('usrEmail'),
            ip: retornoIP.data.ip,
            first_name: localStorage.getItem('usrName'),
            last_name: ' ',
            document: localStorage.getItem('usrCpf'),
            billing_address: {
              city: costumerBillinAdrres.cidade || 'São Paulo',
              country: costumerBillinAdrres.pais || 'Brasil',
              house_number_or_name: costumerBillinAdrres.numero || '377',
              postal_code: costumerBillinAdrres.cep ? costumerBillinAdrres.cep.replace('-', '') : '01009906',
              state: costumerBillinAdrres.estado || 'SP',
              street: costumerBillinAdrres.rua || 'Rua Líbero Badaró',
            },
          },
          extract_identification: 'IEPTB-BR',
          pre_capture: false,
          has_split_rules: false,
          confirmation_required: false,
        };

        web_component.onChange = () => {};
        web_component.beforeSubmit = () => self.$refs['modalLoadingPgto'].show();
        web_component.onSubmit = (state) => {
          self.$refs['modalLoadingPgto'].show();
          if (state.resultCode === 'Authorised') {
            self.$emit('pagamento-cartao-autorizado', state.sale_id);
          } else {
            self.$refs['modalLoadingPgto'].hide();
            self.$refs['ModalPagamentoCartaoRealtime'].show();
          }
        };
      }, 10);
    },

    async simulacaoPagamentos(vlr_simulacao) {
      try {
        const valor_simulado = parseFloat(vlr_simulacao).toFixed(2).replace('.', '') / 1;
        const resSimulacao = await axios.get(
          `${process.env.VUE_APP_URL_EXPRESS}/v1/simulation/sellers/${process.env.VUE_APP_SELLER_KEY_EXPRESS}?amount_cents=${valor_simulado}`
        );
        const formasPagamentoSimulacao = resSimulacao.data.filter(d => d.type === 'credit');
        this.formasPagamentoExpress = formasPagamentoSimulacao;

        // Monta novo array com as opções base (prop) + opções de CC simuladas
        // Usa atribuição completa para garantir reatividade no Vue 2
        const novasOpcoes = [...this.formasPagamento];
        formasPagamentoSimulacao.forEach(value => {
          novasOpcoes.push({
            html: '<b> Cartão de Crédito - Parcela Express  ' + value.installment + ' x ' + this.formataReais(value.installment_amount_cents) + '</b> ( Tarifa Bancária - ' + value.cet + '% )',
            value: value.code,
          });
        });
        this.formasPagamentoOpcoes = novasOpcoes;
      } catch (e) {
        console.warn('Não foi possível simular pagamentos CC', e);
      }
    },

    formataReais(number) {
      number = parseFloat(number / 100).toFixed(2);
      return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2 }).format(number);
    },

    startCountDown(duration) {
      let secondsRemaining = duration;
      const self = this;
      const countInterval = setInterval(() => {
        const sec = parseInt(secondsRemaining % 60);
        self.secondcd = sec;
        secondsRemaining -= 1;
        if (secondsRemaining < 0) clearInterval(countInterval);
      }, 1000);
    },

    async verificaPagamento(cd_boleto) {
      const token = localStorage.getItem('jwtToken');
      const res = await API.post('certidao/consultapagamento', { token, cd_boleto });
      if (res.data.status === 'succeeded') {
        this.$refs['modalBoletoRealtime'].hide();
        this.$emit('pagamento-realizado');
      }
    },

    copiarLink() {
      const textarea = this.$refs['copiarRealtime'];
      if (textarea) {
        textarea.select();
        document.execCommand('copy');
      }
    },
  },
};
</script>
